/**
 * External dependencies.
 */
import {
	InspectorControls,
	useBlockProps,
	__experimentalUnitControl as UnitControl, // eslint-disable-line
	MediaUpload,
} from '@wordpress/block-editor';
import {
	__experimentalToggleGroupControl as ToggleGroupControl, // eslint-disable-line
	__experimentalToggleGroupControlOption as ToggleGroupControlOption, // eslint-disable-line
	PanelBody,
	ToggleControl,
	Notice,
} from '@wordpress/components';

import { __, _x } from '@wordpress/i18n';

export default ( {
	attributes: { elements, logo, logoDark, width, stacked, responsivesidenavigation },
	setAttributes,
} ) => {
	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: 'suredash-portal__editor-identity portal-content portal-branding-section sd-flex',
	} );

	const siteIdentityClass = stacked
		? 'portal-site-identity portal-logo-title-stacked'
		: 'portal-site-identity';

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={ __( 'Elements Visibility', 'suredash' ) }
						value={ elements }
						// eslint-disable-next-line
						onChange={ ( elements ) =>
							setAttributes( { elements } )
						}
						isBlock
					>
						<ToggleGroupControlOption
							value="logo"
							label={ _x(
								'Logo',
								'Showcase only logo',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="title"
							label={ _x(
								'Title',
								'Showcase only title',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="both"
							label={ _x(
								'Both',
								'Showcase both logo and title',
								'suredash'
							) }
						/>
					</ToggleGroupControl>

					{ elements !== 'title' && (
						<>
							<p style={ { marginTop: '16px', marginBottom: '8px' } }>
								{ __( 'Logo for Light Mode', 'suredash' ) }
							</p>
							<MediaUpload
								onSelect={ ( media ) => {
									setAttributes( {
										logo: media?.url || '',
									} );
								} }
								allowedTypes={ [ 'image' ] }
								value={ logo }
								render={ ( { open } ) => (
									<div
										className="portal-logo-upload"
										style={ {
											marginTop: '12px',
											marginBottom: '12px',
										} }
									>
										{ logo ? (
											<div className="portal-logo-wrapper">
												<img // eslint-disable-line
													src={ logo }
													alt={ __(
														'SureDash Portal Logo (Light Mode)',
														'suredash'
													) }
													style={ {
														width: '100%',
														height: 'auto',
														display: 'block',
														borderRadius: '3px',
														boxShadow:
															'0 1px 3px rgba(0,0,0,0.1)',
													} }
													onClick={ open }
												/>

												<div
													style={ {
														marginTop: '12px',
														display: 'flex',
														gap: '8px',
													} }
												>
													<button
														type="button"
														className="components-button is-primary"
														// style={ { flex: 1 } }
														onClick={ open }
													>
														{ __(
															'Change Logo',
															'suredash'
														) }
													</button>

													<button
														type="button"
														className="components-button is-secondary"
														onClick={ () =>
															setAttributes( {
																logo: '',
															} )
														}
													>
														{ __(
															'Remove',
															'suredash'
														) }
													</button>
												</div>
											</div>
										) : (
											<button
												type="button"
												className="components-button button button-primary"
												onClick={ open }
											>
												{ __(
													'Upload Logo',
													'suredash'
												) }
											</button>
										) }
									</div>
								) }
							/>

							<p style={ { marginTop: '16px', marginBottom: '8px' } }>
								{ __( 'Logo for Dark Mode', 'suredash' ) }
							</p>
							<MediaUpload
								onSelect={ ( media ) => {
									setAttributes( {
										logoDark: media?.url || '',
									} );
								} }
								allowedTypes={ [ 'image' ] }
								value={ logoDark }
								render={ ( { open } ) => (
									<div
										className="portal-logo-upload"
										style={ {
											marginTop: '12px',
											marginBottom: '12px',
										} }
									>
										{ logoDark ? (
											<div className="portal-logo-wrapper">
												<img // eslint-disable-line
													src={ logoDark }
													alt={ __(
														'SureDash Portal Logo (Dark Mode)',
														'suredash'
													) }
													style={ {
														width: '100%',
														height: 'auto',
														display: 'block',
														borderRadius: '3px',
														boxShadow:
															'0 1px 3px rgba(0,0,0,0.1)',
													} }
													onClick={ open }
												/>

												<div
													style={ {
														marginTop: '12px',
														display: 'flex',
														gap: '8px',
													} }
												>
													<button
														type="button"
														className="components-button is-primary"
														// style={ { flex: 1 } }
														onClick={ open }
													>
														{ __(
															'Change Logo',
															'suredash'
														) }
													</button>

													<button
														type="button"
														className="components-button is-secondary"
														onClick={ () =>
															setAttributes( {
																logoDark: '',
															} )
														}
													>
														{ __(
															'Remove',
															'suredash'
														) }
													</button>
												</div>
											</div>
										) : (
											<button
												type="button"
												className="components-button button button-primary"
												onClick={ open }
											>
												{ __(
													'Upload Logo',
													'suredash'
												) }
											</button>
										) }
									</div>
								) }
							/>

							<UnitControl
								label={ __( 'Logo Size', 'suredash' ) }
								__unstableInputWidth="100px"
								value={ width }
								// eslint-disable-next-line
								onChange={ ( width ) =>
									setAttributes( { width } )
								}
							/>

							<Notice
								status="info"
								className="logo-dimension-settings-notice"
								isDismissible={ false }
							>
								<strong>
									{ __(
										'Info:',
										'suredash'
									) }
								</strong>
								{ ' ' }
								{ __(
									'Learn more about the recommended image sizes',
									'suredash'
								) }
								{ ' ' }
								<a
									href="https://suredash.com/docs/recommended-image-sizes-for-suredash/"
									target="_blank"
									rel="noreferrer"
								>
									{ __( 'here', 'suredash' ) }
								</a>
								{ '.' }
							</Notice>
						</>
					) }

					{ elements === 'both' && (
						<ToggleControl
							label={ __( 'Stack Logo & Title', 'suredash' ) }
							checked={ stacked }
							// eslint-disable-next-line
							onChange={ ( stacked ) =>
								setAttributes( { stacked } )
							}
						/>
					) }

					<ToggleControl
						label={ __(
							'Responsive: Aside Navigation Trigger',
							'suredash'
						) }
						checked={ responsivesidenavigation }
						// eslint-disable-next-line
						onChange={ ( responsivesidenavigation ) =>
							setAttributes( { responsivesidenavigation } )
						}
					/>
					<Notice
						status="info"
						className="spectra-sidebar-settings-notice"
						isDismissible={ false }
					>
						{ __(
							'In responsive mode, the side navigation trigger appears aside to Identity block.',
							'suredash'
						) }
						<br />
						<br />
						{ __(
							'You also have other option to keep is aside of Title block.',
							'suredash'
						) }
					</Notice>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<div className="portal-banner-heading sd-no-space">
					<a // eslint-disable-line
						href="javascript:void(0)"
						className={ siteIdentityClass }
					>
						{ ' ' }
						{ /* eslint-disable-line */ }
						{ ( elements === 'both' || elements === 'logo' ) &&
							( logo || logoDark ) && (
							<img
								src={ logo || logoDark }
								className="portal-logo"
								style={ {
									maxWidth: width,
									width: '100%',
								} }
								alt={ logo ? 'SureDash Portal Logo (Light Mode)' : 'SureDash Portal Logo (Dark Mode)' }
							/>
						) }
						{ ( elements === 'both' ||
							elements === 'title' ) && (
							<span>
								{ ' ' }
								{
									portal_blocks.blocks_required_configs
										.portal_name
								}{ ' ' }
							</span>
						) }
					</a>
				</div>
			</div>
		</>
	);
};
